import Vuex, { Payload, Store } from 'vuex';
import VuexPersistence from 'vuex-persist';
import { SaveableTypes, SaveableTypeStoreLocation, SaveableObject, ISaveableTypeDescriptor } from '@/app-modules/store/modules';

class StoreConfiguration {
  private readonly vuexPersistLocal: VuexPersistence<any, Payload>;
  private readonly vuexPersistSession: VuexPersistence<any, Payload>;
  private readonly store: Store<any>;

  constructor() {
    const modules = this.initialiseStateActionModules();
    this.vuexPersistLocal = this.initialiseLocalStorage();
    this.vuexPersistSession = this.initialiseSessionStorage();
    this.store = this.initialiseStore(modules);
  }

  public getStore(): Store<any> {
    return this.store;
  }

  private initialiseStateActionModules(): any {
    const modules: any = {};
    SaveableTypes.forEach((saveableType) => {
      modules[saveableType.name] = this.generateStateActionsFor(saveableType.type);
    });
    return modules;
  }

  private generateStateActionsFor(persistedObject: new () => SaveableObject) {
    return {
      namespaced: true,
      state: new persistedObject(),
      getters: {
        get(state: SaveableObject): SaveableObject {
          return state;
        }
      },
      mutations: {
        save(state: SaveableObject, model: SaveableObject): void {
          state = model;
        },
        reset(state: SaveableObject): void {
          const tempState = new persistedObject();
          for (const key in tempState) {
            if (state.hasOwnProperty(key)) {
              (state as any)[key] = (tempState as any)[key];
            }
          }
        }
      }
    };
  }

  private initialiseLocalStorage(): VuexPersistence<any, Payload> {
    const localStorageSaveableTypes = SaveableTypes.filter((element) => element.storeLocation === SaveableTypeStoreLocation.LocalStorage);
    return this.initialiseStorage(localStorageSaveableTypes, window.localStorage);
  }

  private initialiseSessionStorage(): VuexPersistence<any, Payload> {
    const sessionStorageSaveableTypes = SaveableTypes.filter((element) => element.storeLocation === SaveableTypeStoreLocation.SessionStorage);
    return this.initialiseStorage(sessionStorageSaveableTypes, window.sessionStorage);
  }

  private initialiseStorage(saveableTypes: ISaveableTypeDescriptor[], storage: Storage): VuexPersistence<any, Payload> {
    return new VuexPersistence<any, Payload> ({
      storage,
      key: 'store',
      filter: (mutation) => {
        for (const mutationAction of ['save', 'reset']) {
          for (const saveableType of saveableTypes) {
            if (mutation.type === `${saveableType.name}/${mutationAction}`) {
              return true;
            }
          }
        }
        return false;
      },
      modules: saveableTypes.map((saveableType) => saveableType.name)
    });
  }

  private initialiseStore(modules: any): Store<any> {
    return new Vuex.Store<any>({
      modules,
      plugins: [ this.vuexPersistLocal.plugin, this.vuexPersistSession.plugin ]
    });
  }
}

export { StoreConfiguration };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/persisted-store/store-configuration.ts